export default {
  labels: {
    google_place: 'Lugar de Google',
    live: 'En vivo',
    setting_up: 'Configurando',
  },
  buttons: {
    confirm: 'Confirmar',
    cancel: 'Cancelar',
    continue_setup: 'Continuar configuración',
  },
  delete_confirmation: '¿Está seguro?',
};
